<info-page>
  <ng-template #image><img alt="" src="/assets/images/evaluation/complete.png" /></ng-template>
  <ng-template #title>Thank You!</ng-template>
  <ng-template #description>
    Thank you for your feed-back. It is highly appreciated and will help us to continue delivering Top Class consultants
    in the future. If you have any comments or questions, please feel free to
    <a href="mailto:{{ evaluationData.Agent.Email }}">contact your Darize Agent</a>
    .
  </ng-template>
</info-page>
